import { RECETA_OUTPUT_PRODUCT_TYPES } from '../data/mockRecetasClassification';

export const PRODUCCION_GUIA_TYPES = {
  producto_terminado: {
    slug: 'producto-terminado',
    guideType: 'producto_terminado',
    title: 'Guía de producto terminado',
    shortTitle: 'Producto terminado',
    description: 'Registro de elaboración de recetas con salida para venta.',
  },
  producto_en_proceso: {
    slug: 'producto-en-proceso',
    guideType: 'producto_en_proceso',
    title: 'Guía de producto en proceso',
    shortTitle: 'Producto en proceso',
    description: 'Registro de elaboración de recetas con salida intermedia.',
  },
};

export function getGuiaConfigBySlug(slug) {
  return Object.values(PRODUCCION_GUIA_TYPES).find((c) => c.slug === slug) || null;
}

export function getGuiaConfigByGuideType(guideType) {
  return PRODUCCION_GUIA_TYPES[guideType] || null;
}

export function outputTypeLabel(guideType) {
  const hit = RECETA_OUTPUT_PRODUCT_TYPES.find((o) => o.value === guideType);
  return hit?.label || guideType;
}
